import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule, getCurrencySymbol, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { DEFAULT_CURRENCY_CODE, InjectionToken, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import {
    KAL_FORM_FIELDS_GLOBAL_OPTIONS,
    KAL_SELECT_GLOBAL_OPTIONS,
    KalFormFieldOptions,
    KalSelectOptions
} from '@kalidea/kaligraphi';
import { EmptyFocusComponent } from 'src/app/_core/components/empty-focus/empty-focus.component';
import { LayoutNavComponent } from 'src/app/_core/components/layout-nav/layout-nav.component';
import { LayoutComponent } from 'src/app/_core/components/layout/layout.component';
import { GraphQLModule } from 'src/app/_core/graphql.module';
import { FullScreenDialogComponent } from 'src/app/_core/services/fullscreen.service';
import { InjectorProviderService } from 'src/app/_core/services/injector.provider.service';
import { StoreProviderService } from 'src/app/_core/services/store.provider.service';
import { StateManagementModule } from 'src/app/_core/state.management.module';

import { SharedModule } from 'src/app/_shared/shared.module';
import { errors } from 'src/environments/form-errors';
import { requiredValidatorKeys } from 'src/environments/form-required-validator-key';

registerLocaleData(localeFr, 'fr');

// default config for tinymce
(window as any).tinyMCE.overrideDefaults({
    base_url: '/tinymce/',  // Base for assets such as skins, themes and plugins
    language: 'fr_FR',
    license_key: 'gpl',
    language_url: '/assets/langs/fr_FR.js',
});
export const CURRENCY: InjectionToken<string> = new InjectionToken<string>('CURRENCY');

@NgModule({
    declarations: [
        LayoutComponent,
        LayoutNavComponent,
        EmptyFocusComponent,
        FullScreenDialogComponent
    ],
    imports: [
        CommonModule,
        GraphQLModule,
        RouterModule,
        StateManagementModule.forRoot(),
        SharedModule,
        OverlayModule,
        PortalModule,
        BrowserAnimationsModule
    ],
    exports: [
        LayoutComponent
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'fr-FR'},
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
        {
            provide: CURRENCY,
            deps: [DEFAULT_CURRENCY_CODE, LOCALE_ID],
            useFactory: (code: string, locale: string) => getCurrencySymbol(code, 'narrow', locale) // todo remplacer getCurrencySymbol qui est déprécié
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class CoreModule {
    constructor(private injector: InjectorProviderService,
                private factory: StoreProviderService) {
    }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                {
                    provide: KAL_FORM_FIELDS_GLOBAL_OPTIONS,
                    useValue: {
                        showError: true,
                        requiredValidatorKeys,
                        errors
                    } as KalFormFieldOptions
                },
                {
                    provide: KAL_SELECT_GLOBAL_OPTIONS,
                    useValue: {
                        displayCheckboxOnMultipleSelection: true,
                        triggerValueFunction: selection => selection.length === 1
                            ? selection[0].getLabel() : selection.length + ' éléments'
                    } as KalSelectOptions
                }
            ]
        };
    }
}
